module.exports = __webpack_public_path__ + "static/img/i33.aa0b842.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cpzy/i33.png
// module id = O9lc
// module chunks = 3